import React from 'react';

import { FavoriteHeartProvider, ProductFavoriteHeart } from '@vp/favorites-heart-v2';

export interface FavoritesHeartWrapperProps {
  mpvId: string;
  productName: string;
  productKey: string;
  productVersion: number;
}

export const FavoritesHeartWrapper: React.FC<FavoritesHeartWrapperProps> = (props) => {
  return (
    <FavoriteHeartProvider pageSection={'Product Page'} disableLogging={true}>
      <ProductFavoriteHeart
        productKey={props.productKey}
        productVersion={props.productVersion}
        selectedOptions={{}}
        productName={props.productName}
        mpvId={props.mpvId}
        pageZone="Product Image"
      />
    </FavoriteHeartProvider>
  );
};
